import React from 'react'

const Anasayfa = props => {
    return(
        <div>Düzenlenecek</div>
    )
}

export default Anasayfa